var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ResponsiveLine } from '@nivo/line';
import * as moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import { useEffect, useState, memo } from 'react';
import { useTheme } from 'styled-components';
import { ChartWrapper } from './styles';
import { getLineOptionsByVariant } from '../../lineOptions';
import { AreaLegend as ChartAreaLegend } from '../AreaLegend';
import { LinesLegend as ChartLinesLegend } from '../LinesLegend/LinesLegend';
var mapPointToChanceValues = function (point, yFormat) {
  return {
    lowestChance: yFormat(point.lowConfidenceYHigh),
    lowChance: yFormat(point.highConfidenceYHigh),
    highChance: yFormat(point.highConfidenceYLow),
    highestChance: yFormat(point.lowConfidenceYLow)
  };
};
export var DefaultChart = function (props) {
  var areasLegendText = props.areasLegendText,
    areasLegendType = props.areasLegendType,
    chartLineForContribution = props.chartLineForContribution,
    chartLineForProjection = props.chartLineForProjection,
    chartTooltipText = props.chartTooltipText,
    linesLegendType = props.linesLegendType,
    projectionData = props.projectionData,
    yFormat = props.yFormat;
  var linesLegendInfo = {
    contributionText: chartTooltipText.contributionText,
    contributionValue: yFormat(chartLineForContribution.data.slice(-1)[0].y),
    projectionText: chartTooltipText.projectionText,
    projectionValue: yFormat(projectionData.y)
  };
  var defaultChanceValues = mapPointToChanceValues(projectionData, yFormat);
  var _a = useState(defaultChanceValues),
    chanceValues = _a[0],
    setChanceValues = _a[1];
  useEffect(function () {
    setChanceValues(defaultChanceValues);
  }, [chartLineForProjection]);
  return _jsxs(_Fragment, {
    children: [_jsx(ChartLinesLegend, __assign({
      type: linesLegendType
    }, linesLegendInfo)), _jsx(ChartWrapper, {
      children: _jsx(LineChartComponent, __assign({
        defaultChanceValues: defaultChanceValues,
        setChanceValues: setChanceValues
      }, props))
    }), _jsx(ChartAreaLegend, {
      chanceValues: chanceValues,
      chartAreasLegendText: areasLegendText,
      type: areasLegendType
    })]
  });
};
export var LineChartComponent = memo(function (_a) {
  var chartLineForContribution = _a.chartLineForContribution,
    chartLineForProjection = _a.chartLineForProjection,
    chartTooltipText = _a.chartTooltipText,
    defaultChanceValues = _a.defaultChanceValues,
    setChanceValues = _a.setChanceValues,
    xAxisFormatter = _a.xAxisFormatter,
    xFormat = _a.xFormat,
    xTickValues = _a.xTickValues,
    yAxisFormatter = _a.yAxisFormatter,
    yFormat = _a.yFormat;
  var theme = useTheme();
  var onDataPointChange = function (dataPoint) {
    var currProjectionValue = chartLineForProjection.data.find(function (x) {
      return moment(x.x).isSame(dataPoint.x, 'day');
    });
    var currContributionValue = chartLineForContribution.data.find(function (x) {
      return moment(x.x).isSame(dataPoint.x, 'day');
    });
    if (currProjectionValue) {
      setChanceValues(mapPointToChanceValues(currProjectionValue, yFormat));
    }
    if (currProjectionValue && currContributionValue) {
      return {
        selectedPointYear: dataPoint.x.getFullYear(),
        pointProjectionYValue: yFormat(currProjectionValue.y),
        pointContributionYValue: yFormat(currContributionValue.y)
      };
    }
    return null;
  };
  return _jsx(ResponsiveLine, __assign({}, getLineOptionsByVariant('default', {
    chartLineForContribution: chartLineForContribution,
    chartLineForProjection: chartLineForProjection,
    chartTooltipText: chartTooltipText,
    defaultChanceValues: defaultChanceValues,
    onDataPointChange: onDataPointChange,
    setChanceValues: setChanceValues,
    theme: theme,
    xAxisFormatter: xAxisFormatter,
    xFormat: xFormat,
    xTickValues: xTickValues,
    yAxisFormatter: yAxisFormatter,
    yFormat: yFormat
  })));
}, function (prevProps, nextProps) {
  return prevProps.chartLineForContribution === nextProps.chartLineForContribution && prevProps.chartLineForProjection === nextProps.chartLineForProjection && prevProps.xTickValues === nextProps.xTickValues;
});
LineChartComponent.displayName = 'LineChartComponent';